import classes from "../../styles/Modal.module.css";
import { useEffect, useState } from "react";
import { dispatchEvent, getClasses } from "../../utils";
import { useAppSelector } from "../../hooks";
import Modal, { ModalProps } from "./Modal";
import { useDispatch } from "react-redux";
import ModalButton from "../buttons/ModalButton";
import { hideRealityCheck } from "../../store/slices/reality-check";
import { closeModal, openModal } from "../../store/slices/modals";
import Commander from "../../commander";
import { EVENTS } from "../../commander/Types";

const formatTime = (time: number): string => {
  const fullSeconds = time;
  const hours = Math.floor(fullSeconds / 60 / 60);
  const minutes = Math.floor((fullSeconds / 60) % 60);
  const seconds = Math.floor(fullSeconds % 60);
  const hoursStr = hours !== 1 ? "hours" : "hour";
  const minutesStr = minutes !== 1 ? "minutes" : "minute";
  const secondsStr = minutes !== 1 ? "seconds" : "second";

  if (seconds !== 0) {
    return `${hours} ${hoursStr}, ${minutes} ${minutesStr} and ${seconds} ${secondsStr}`;
  } else {
    return `${hours} ${hoursStr} and ${minutes} ${minutesStr}`;
  }
};

const RealityCheck: React.FC<ModalProps> = ({ shown }) => {
  const dispatch = useDispatch();
  const [hadAutoplay, setHadAutoplay] = useState({ value: 0, limit: {} });
  const { visible, time, historyURL, lobby, autoplay } = useAppSelector(
    (state) => {
      return {
        ...state.realityCheck,
        lobby: state.details.lobby,
        autoplay: state.autoplay,
      };
    }
  );

  const quitHandler = () => {
    if (lobby) {
      window.open(lobby, "_self");
    } else {
      window.history.back();
    }
  };

  const closeHandler = () => {
    dispatch(hideRealityCheck());
    dispatch(closeModal());

    if (hadAutoplay.value > 0) Commander.startAutoplay(hadAutoplay.value);
    dispatchEvent(EVENTS.REALITY_CHECK_CLOSED);
  };

  const historyHandler = () =>
    dispatchEvent(EVENTS.OPEN_EXTERNAL_HISTORY, historyURL);

  useEffect(() => {
    if (!visible) return;

    setHadAutoplay(autoplay);
    Commander.stopAutoplay();
    dispatch(openModal("realityCheck"));
  }, [visible, dispatch, autoplay]);

  return (
    <Modal
      className={getClasses(classes, "message", "prompt-modal")}
      shown={shown && visible}
      icon="Info"
      title="Reality Check"
      onClose={closeHandler}
    >
      <div className={classes["content-main"]}>
        <div className={classes.message}>{`You've been playing for ${formatTime(
          time
        )}`}</div>
      </div>
      <div className={classes["content-buttons"]}>
        <ModalButton
          name="quiterc"
          className={getClasses(classes, "button")}
          available={true}
          onClick={quitHandler}
        >
          Quit game
        </ModalButton>
        <ModalButton
          name="historyrc"
          className={getClasses(classes, "button")}
          available={!!historyURL}
          onClick={historyHandler}
        >
          Go to History
        </ModalButton>
        <ModalButton
          name="continuerc"
          type="accent"
          className={classes.button}
          available={true}
          onClick={closeHandler}
        >
          Continue
        </ModalButton>
      </div>
    </Modal>
  );
};

export default RealityCheck;
